import { TextValeur } from 'src/app/core/models/TextValeur';

export class ProfilDto {
  id?: number; // individuActiviteProfilId
  profil: TextValeur<number>;
  dateDebut?: Date;
  dateFin?: Date;
  activiteId?: number;

  get isActif() {
    return (!this.dateDebut || new Date(this.dateDebut) < new Date()) && (!this.dateFin || new Date(this.dateFin) > new Date());
  }

  constructor(init?: Partial<ProfilDto>) {
    Object.assign(this, init);
  }
}
